import React, { useEffect } from 'react';
import { motion } from "framer-motion";

import wo from "../assets/Wo.webp";
import br from "../assets/BR.webp";
import bm from "../assets/BM.webp";
import bbb from "../assets/BB.svg";
import s1 from "../assets/S1.svg";
import s2 from "../assets/S2.svg";
import s3 from "../assets/S3.svg";
import t1 from "../assets/T1.png";
import t2 from "../assets/T2.png";
import t3 from "../assets/T3.png";
import { Helmet } from "react-helmet-async";

import { useRef } from "react";

const Edu = () => {

  // const [openDropdown, setOpenDropdown] = useState(null);
  const navRef = useRef(null);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navRef.current && !navRef.current.contains(event.target)) {
        // setOpenDropdown(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const cards = [
    {
      title: "Easy registration & enrollment",
      desc: "Begin your journey by filling out the form, selecting your department and clicking 'Register' to submit your application.",
      bgImage: s1,
      color: "#5ECC9F",
      text: "text-gray-900",
    },
    {
      title: "Personalized Dashboard",
      desc: "Access your personalized dashboard to explore programs, track your application, manage payments and receive task reminders.",
      bgImage: s2,
      color: "#0A0A0A",
      text: "text-white",
    },
    {
      title: "Supportive features",
      desc: "We offer tools designed to enhance your learning experience and support your academic success through a seamless, engaging environment.",
      bgImage: s3,
      color: "#CA9BFB",
      text: "text-gray-900",
    },
    {
      title: "Essential academic resources",
      desc: "Our website is your central hub for easy access to academic resources and course updates.",
      bgImage: s2,
      color: "#0A0A0A",
      text: "text-white",
    },
    {
      title: "Bridging theory & Practice",
      desc: "Our courses bridge theory and practice by offering practical training that meets both academic and industry needs.",
      bgImage: s1,
      color: "#5ECC9F",
      text: "text-gray-900",
    },
    {
      title: "Training & Placement opportunities",
      desc: "Our strong support and preparation help students excel in competitive job markets and launch successful, rewarding careers.",
      bgImage: s3,
      color: "#CA9BFB",
      text: "text-gray-900",
    },
  ];

  const features = [
    {
      icon: t1,
      bg: "bg-[#DFFCF3]",              // soft mint
      title: "Dedicated to you",
      desc:
        "Join our vibrant community where expert mentors support your journey to academic and professional success.",
    },
    {
      icon: t2,
      bg: "bg-[#F4F1FF]",              // pastel lavender
      title: "Impact on industry",
      desc:
        "Lentera links candidates with partners to deliver real‑world training and skill‑building.",
    },
    {
      icon: t3,
      bg: "bg-[#E8FFE9]",              // light green
      title: "Call to action",
      desc:
        "Join Lentera’s thriving learning community to gain the tools and support you need for career growth and success.",
    },
  ];

  return (
    <div>
      <Helmet>
        <title>LENTERA education programs, hands-on-training support.</title>
        <meta name="description" content="Empower students with LENTERA’s dynamic education programs. Gain industry-relevant skills, hands-on training, personalized dashboards and seamless access to resources for academic success and career readiness." />
        <meta name="keywords" content="LENTERA education programs, hands-on-training support." />
      </Helmet>

      <section className="w-full bg-[#FFF0EF] py-20 px-4 sm:px-6">
        <div className="w-full max-w-[1312px] mx-auto flex flex-col lg:flex-row items-center justify-between gap-10">

          {/* Left Column – 60% with animation */}
          <motion.div
            className="w-full lg:w-[60%]"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, ease: "easeOut" }}
          >
            <h5 className="text-[#212129] text-sm font-medium uppercase mb-3 tracking-wide">
              Education
            </h5>

            <h2 className="text-[#1E1E1E] text-[40px] md:text-[48px] font-extrabold leading-tight mb-6">
              Where learning meets <br /> limitless possibilities
            </h2>

            <p className="text-[#4A4A4A] text-base leading-relaxed max-w-[580px]">
              We provide the tools, guidance and inspiration to help you unlock  <br /> your full potential and create a future without limits.
            </p>
          </motion.div>

          {/* Right Column – 40% with animation */}
          <motion.div
            className="w-full lg:w-[40%] flex justify-center"
            initial={{ opacity: 0, x: 60 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2, ease: "easeOut" }}
          >

            <img
              src={wo}
              alt="Learning Illustration"
              className=" max-w-[420px] object-contain"
            />
          </motion.div>
        </div>
      </section>

      <section className="w-full bg-white py-16 px-4 sm:px-6 lg:px-12">
        {/* Top Overview Section */}
        <div className="max-w-6xl mx-auto flex flex-col lg:flex-row justify-between items-start gap-6 mb-12">
          {/* Heading */}
          <motion.h2
            className="text-[36px] sm:text-[42px] md:text-[48px] font-extrabold text-[#1A1A1A]"
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            Overview
          </motion.h2>

          {/* Paragraph */}
          <motion.p
            className="text-[#3D3D3D] text-[16px] md:text-[16px] leading-[28px] max-w-2xl"
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
          >
            Welcome to a dynamic learning space that prepares students for real-world challenges
            and evolving industry needs. Through hands-on teaching and bridging academics with
            business, we build practical skills. Our graduates are ready to succeed in today’s
            competitive professional world.
          </motion.p>
        </div>

        <div className="px-4">
          <div className="bg-[#1E1E1E] rounded-[40px] text-white px-6 md:px-12 py-10 md:py-16 flex flex-col md:flex-row items-center justify-between max-w-6xl mx-auto">
            {/* Left Image */}
            <div className="w-full md:w-1/2 flex justify-center mb-10 md:mb-0">
              <img
                src={br}
                alt="Education Impact Visual"
                className="w-3/4 md:w-[400px] h-auto mr-20"
              />
            </div>

            {/* Right Text Content */}
            <div className="w-full md:w-1/2 text-center md:text-left">
              <h2 className="text-2xl md:text-4xl font-bold leading-tight mb-6">
                Our impact on the <br className="hidden md:block" /> education industry
              </h2>
              <p className="text-sm md:text-base text-gray-300 leading-relaxed">
                Educational institutions can enhance efficiency and provide seamless access to resources by integrating services like content repositories, learning management systems and student information systems.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-white font-poppins px-6 md:px-12 lg:px-20 py-16">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-20">
          {/* Left 60% */}
          <div className="w-full lg:w-[60%]">
            {/* Capsule Label */}
            <span className="inline-block bg-[#D6F8CB] text-[#028A0F] text-xs font-semibold px-4 py-1 rounded-full mb-5">
              FOR GREAT FUTURE
            </span>

            {/* Heading */}
            <h2 className="text-[36px] sm:text-[42px] lg:text-[52px] leading-tight font-bold text-[#1A1A1A] mb-6">
              Dynamic learning <br className="hidden sm:block" />
              community, embracing <br className="hidden sm:block" />
              your future
            </h2>

            {/* Description */}
            <p className="text-[16px] text-[#3D3D3D] leading-relaxed">
              We provide practical, comprehensive education to meet today’s industry
              needs. Our programs blend academics with real-world experience.
              Graduates gain skills to succeed in a fast-paced workforce.
            </p>
          </div>

          {/* Right 40% */}
          <div className="w-full lg:w-[40%] flex justify-center">
            <img
              src={bm}
              alt="Learning Illustration"
              className="w-full max-w-md"
            />
          </div>
        </div>
      </section>

      <section className="bg-[#1D1D26] text-white py-16 px-4">
        <div className="max-w-7xl mx-auto">
          {/* Top: Heading & Text */}
          <div className="flex flex-col lg:flex-row justify-between items-center lg:items-start gap-8">
            <h2 className="text-4xl sm:text-5xl font-semibold leading-tight ml-20">
              Your benefits <br /> with us
            </h2>
            <p className="text-lg sm:text-[16px] text-gray-300 max-w-xl text-left mr-20">
              Experience hands-on learning, industry-relevant skills and dedicated <br />
              support that empower you to thrive in the real world.
            </p>
          </div>

          {/* Bottom: Centered Image */}
          <div className="mt-16 flex justify-center">
            <img
              src={bbb}
              alt="Benefits illustration"
              className="w-full max-w-5xl h-auto object-contain mr-20"
            />
          </div>
        </div>
      </section>

      <section className="bg-white py-12 px-4">
        <div className="max-w-5xl mx-auto text-center">
          <h2 className="text-1xl sm:text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900">
            Supporting your academic journey
          </h2>

          <p className="mt-6 text-base sm:text-lg md:text-[15px] text-gray-600 leading-normal">
            We provide the guidance, resources and real-world learning opportunities you need to grow <br />
            confidently and succeed at every step of your education.
          </p>
        </div>
      </section>

      <section className="py-12 px-4 sm:px-6 md:px-8 lg:px-12 bg-white -mt-10">
        <div className="max-w-screen-xl mx-auto flex flex-col items-center space-y-8">

          {/* Row 1 */}
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
            {cards.slice(0, 3).map((c, i) => (
              <div
                key={i}
                className={`relative w-full max-w-[360px] rounded-lg p-6 shadow-lg bg-cover bg-center text-center 
                      flex flex-col justify-center items-center overflow-hidden ${c.text}`}
                style={{ backgroundImage: `url(${c.bgImage})` }}
              >
                <div className="absolute inset-0 opacity-75" style={{ backgroundColor: c.color }}></div>
                <div className="relative z-10">
                  <h3 className="text-lg sm:text-[17px] font-semibold mb-3">{c.title}</h3>
                  <p className="text-sm sm:text-[13px] leading-relaxed opacity-90">{c.desc}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Row 2 */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {cards.slice(3, 5).map((c, i) => (
              <div
                key={i + 3}
                className={`relative w-full max-w-[360px] rounded-lg p-6 shadow-lg bg-cover bg-center text-center 
                      flex flex-col justify-center items-center overflow-hidden ${c.text}`}
                style={{ backgroundImage: `url(${c.bgImage})` }}
              >
                <div className="absolute inset-0 opacity-75" style={{ backgroundColor: c.color }}></div>
                <div className="relative z-10">
                  <h3 className="text-lg sm:text-[17px] font-semibold mb-3">{c.title}</h3>
                  <p className="text-sm sm:text-[13px] leading-relaxed opacity-90">{c.desc}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Row 3 */}
          <div className="flex justify-center">
            {(() => {
              const c = cards[5];
              return (
                <div
                  className={`relative w-full max-w-[360px] rounded-lg p-6 shadow-lg bg-cover bg-center text-center 
                        flex flex-col justify-center items-center overflow-hidden ${c.text}`}
                  style={{ backgroundImage: `url(${c.bgImage})` }}
                >
                  <div className="absolute inset-0 opacity-75" style={{ backgroundColor: c.color }}></div>
                  <div className="relative z-10">
                    <h3 className="text-lg sm:text-[17px] font-semibold mb-3">{c.title}</h3>
                    <p className="text-sm sm:text-[13px] leading-relaxed opacity-90">{c.desc}</p>
                  </div>
                </div>
              );
            })()}
          </div>
        </div>
      </section>

      <section className="w-full py-20 px-6 bg-white font-poppins">
        {/* Heading */}
        <div className="max-w-3xl mx-auto text-center mb-12">
          <h2 className="text-[48px] leading-snug font-semibold text-[#1f1f1f]">
            Key features
          </h2>
          <p className="mt-4 text-gray-600">
            Discover the game‑changing key features that set you apart!
          </p>
        </div>

        {/* Feature Cards */}
        <div className="max-w-7xl mx-auto grid gap-8 grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
          {features.map(({ icon, bg, title, desc }, idx) => (
            <div
              key={idx}
              className={`${bg} rounded-[24px] p-8 md:p-10 flex flex-col h-full`}
            >
              <img src={icon} alt={title} className="w-14 h-14 mb-6" />

              <h3 className="text-[22px] font-semibold text-[#1f1f1f] mb-4">
                {title}
              </h3>

              <p className="text-gray-700 leading-relaxed">{desc}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  )
}

export default Edu